import Task from 'models/task/Task';

export default class UserProfileFieldsTask extends Task {
	constructor(task) {
		super(task);

		this.userProfileFields = task.user_profile_fields;
	}
}
